import { http } from "@/app/http/client";

type SearchResult = {
    data: {
        zipCode: {
            code: string;
            title: string;
            applyTo: string[];
            estimate_rate: number;
        };
        state: {
            tax_limit: boolean;
            tax_status: boolean;
            code: string;
            title: string;
            applyTo: string[];
            installation: boolean;
        };
    },
    error?: string
};

export const searchStateByZipCode = async (
    zip: string,
): Promise<SearchResult> => {
    try {
        const response = await http.get<SearchResult>(`/zip-codes/${zip}`);
        return { data: response.data };
    } catch (error: any) {
        if (error.response.data.error) {
            return {
                data: {
                    zipCode: {
                        code: "",
                        title: "",
                        applyTo: [],
                        estimate_rate: 0
                    },
                    state: {
                        tax_limit: false,
                        tax_status: false,
                        code: "",
                        title: "",
                        applyTo: [],
                        installation: false
                    }
                },
                error: error.response.data.error
            }
        } else {
            console.log("zip-code error", error);
            return null as unknown as SearchResult;
        }
    }
};
